/**
 * Mega Menu Language Change Fix
 * 
 * This script ensures that mega menus are properly re-initialized
 * after language changes in the Shopify theme.
 */

(function() {
  'use strict';

  // Store language change state
  var languageChangeState = {
    isChanging: false,
    previousLang: null,
    currentLang: null
  };

  // Initialize when DOM is ready
  $(document).ready(function() {
    initializeLanguageChangeHandler();
    checkForLanguageChange();
  });

  // Initialize when window loads (for cases where DOM ready isn't enough)
  $(window).on('load', function() {
    checkForLanguageChange();
  });

  /**
   * Initialize language change event handlers
   */
  function initializeLanguageChangeHandler() {
    // Handle language form submissions
    $('.localization-form__button').on('click', function(e) {
      var newLang = $(this).val();
      var currentLang = $('html').attr('lang') || 'en';
      
      if (currentLang !== newLang) {
        languageChangeState.isChanging = true;
        languageChangeState.previousLang = currentLang;
        languageChangeState.currentLang = newLang;
        
        // Store in session storage for persistence across page reload
        sessionStorage.setItem('megaMenuLanguageChange', JSON.stringify(languageChangeState));
      }
    });

    // Handle form submission events
    $('.localization-form').on('submit', function() {
      languageChangeState.isChanging = true;
      sessionStorage.setItem('megaMenuLanguageChange', JSON.stringify(languageChangeState));
    });
  }

  /**
   * Check if language was changed and re-initialize mega menu
   */
  function checkForLanguageChange() {
    var storedState = sessionStorage.getItem('megaMenuLanguageChange');
    
    if (storedState) {
      try {
        var state = JSON.parse(storedState);
        
        if (state.isChanging) {
          // Clear the stored state
          sessionStorage.removeItem('megaMenuLanguageChange');
          
          // Re-initialize mega menu after a delay
          setTimeout(function() {
            reinitializeMegaMenu();
          }, 300);
        }
      } catch (e) {
        console.warn('Error parsing language change state:', e);
        sessionStorage.removeItem('megaMenuLanguageChange');
      }
    }
  }

  /**
   * Re-initialize mega menu functionality
   */
  function reinitializeMegaMenu() {
    // Check if megaMenu function exists and call it
    if (typeof megaMenu === 'function') {
      megaMenu();
    }
    
    // Trigger window resize to ensure proper positioning
    $(window).trigger('resize');
    
    // Re-initialize hover events for mega menu items
    initializeMegaMenuHoverEvents();
    
    // Force recalculation of mega menu positions
    setTimeout(function() {
      if (typeof megaMenu === 'function') {
        megaMenu();
      }
    }, 100);
  }

  /**
   * Initialize hover events for mega menu items
   */
  function initializeMegaMenuHoverEvents() {
    // Remove existing hover events to prevent duplicates
    $('.has-mega-menu').off('mouseenter mouseleave');
    
    // Add hover events for mega menu items
    $('.has-mega-menu').on('mouseenter', function() {
      var $this = $(this);
      var $subMenu = $this.find('.sub-menu-block');
      
      if ($subMenu.length) {
        $subMenu.removeClass('is-hidden').show();
      }
    }).on('mouseleave', function() {
      var $this = $(this);
      var $subMenu = $this.find('.sub-menu-block');
      
      if ($subMenu.length) {
        $subMenu.addClass('is-hidden').hide();
      }
    });
  }

  /**
   * Utility function to force mega menu refresh
   * Can be called manually if needed
   */
  window.refreshMegaMenu = function() {
    reinitializeMegaMenu();
  };

  /**
   * Debug function to check mega menu state
   */
  window.debugMegaMenu = function() {
    console.log('Mega Menu Debug Info:');
    console.log('- Has megaMenu function:', typeof megaMenu === 'function');
    console.log('- Mega menu items found:', $('.has-mega-menu').length);
    console.log('- Sub menu blocks found:', $('.sub-menu-block').length);
    console.log('- Language change state:', sessionStorage.getItem('megaMenuLanguageChange'));
  };

})(); 